import { appConfig } from "../app.config";
import { ApiError } from "../enums/api-error.enum";
import { ABTest } from "../interfaces/ab-test.interface";
import { IHttpService } from "../interfaces/http-service.interface";
import { Sections } from "../models/calculator-content.model";
import { Client } from "../models/client.model";
import { Lead } from "../models/lead.model";
import { Question } from "../models/question.model";
import { Service } from "../models/service.model";
import { HttpService } from './http.service';

class ApiSerivce {
	constructor(private readonly httpService: IHttpService) { }

	public async getClientData(clientId: string, service?: Service): Promise<Client> {
		let queryParams = `fields[]=common&fields[]=default&fields[]=name`;
		if (service) queryParams += `&fields[]=${service}`;

		try {
			const data = await this.httpService.get<Client>(`/clients/${clientId}?${queryParams}`);
			return data;

		} catch (error) {
			console.error(error);
			return Promise.reject(ApiError.GET_CLIENT_DATA_ERROR);
		}
	}

	public async getContent(service: Service): Promise<any> {
		try {
			const content = await this.httpService.get(`/content/?service=${service}`);
			return content;

		} catch (error) {
			console.error(error);
			return Promise.reject(ApiError.GET_CLIENT_DATA_ERROR);
		}
	}

	public async getQuestions(service: Service, additional = true): Promise<Question[]> {
		try {
			const url = additional ? `/questions/?service=${service}` : `/questions/whithout-additional/?service=${service}`;
			const questions = await this.httpService.get<Question[]>(url);
			return questions;
		} catch (error) {
			return Promise.reject(ApiError.GET_QUESTIONS_ERROR);
		}
	}

	public async getAbTests(clientId: string): Promise<ABTest[]> {
		try {
			const tests = await this.httpService.get<ABTest[]>(`/ab-tests/?clientId=${clientId}&common=1`);
			return tests;

		} catch (error) {
			return [];
		}
	}

	public async addLead(lead: Lead): Promise<Lead> {
		try {
			const receiveLead = await this.httpService.post<Lead>('/leads', lead);
			return receiveLead;

		} catch (error) {
			return Promise.reject(error);
		}
	}

	public async updateLead(id: string, leadFields: Partial<Lead>): Promise<Lead> {
		try {
			const receiveLead = await this.httpService.put<Lead>(`/leads/${id}`, leadFields);
			return receiveLead;

		} catch (error) {
			console.error(error);
			return {} as any;
		}
	}

	public async getDefaultCalculatorContent(service: Service) {
		try {
			const calcContent = await this.httpService.get<Sections[]>(`/content/calculator/${service}`);
			return calcContent;
		} catch (error) {
			console.error(error);
			return [];
		}
	}
}

export const httpService = new HttpService(appConfig());
export const apiService = new ApiSerivce(httpService);